/* bvm-eventi.js — MOTORE EVENTI (E2, 10/10/2026). Nessuna dipendenza, nessun contenuto caricato al clic: tutto è già
   nell'HTML, qui si sceglie, si mostra e si nasconde.
   1) Pagina evento: scelta della sessione (blocco E8) e modulo di prenotazione (E10).
   2) Calendario (L2): cambio del mese; nella pagina elenco il giorno con più eventi filtra l'elenco (L4).
   3) Pannello Eventi (P0): <dialog> apribile da qualsiasi elemento con data-vsb-eventi-apri.
   Senza questo script la pagina resta usabile: l'orario si sceglie dalla tendina del modulo. */
(function () {
  'use strict';
  if (window.__vsbEventi) return;
  window.__vsbEventi = true;

  var fermo = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function tutti(sel, radice) { return Array.prototype.slice.call((radice || document).querySelectorAll(sel)); }
  function scorri(el) { if (el) el.scrollIntoView({ behavior: fermo ? 'auto' : 'smooth', block: 'start' }); }

  /* ═══ 1 · PAGINA EVENTO ═══ */
  function paginaEvento(radice) {
    var formato = radice.getAttribute('data-vsb-formato');
    var titolo = radice.getAttribute('data-vsb-titolo') || '';
    var modulo = radice.querySelector('#vsb-prenota-form');
    var blocco = radice.querySelector('[data-vsb-prenota]');
    var okCard = radice.querySelector('[data-vsb-esito-ok]');
    var errori = radice.querySelector('[data-vsb-esito-errore]');
    var pulsanti = tutti('[data-vsb-sessione]', radice);
    var tendina = radice.querySelector('[data-vsb-orario-scelta]');
    var quando = radice.querySelector('[data-vsb-riepilogo-quando]');
    var esitoQuando = radice.querySelector('[data-vsb-esito-quando]');
    var cambia = radice.querySelector('[data-vsb-cambia]');
    var manca = radice.querySelector('[data-vsb-manca]');
    var annuncio = radice.querySelector('[data-vsb-annuncio]');
    var campoGiorno = radice.querySelector('[data-vsb-campo-giorno]');
    var campoOra = radice.querySelector('[data-vsb-campo-ora]');
    var oggetto = radice.querySelector('[data-vsb-oggetto]');
    var scelta = '';

    // Dopo l'invio Shopify riporta qui: il focus va all'esito (successo o errore).
    if (okCard) { var t = okCard.querySelector('[tabindex]'); if (t) { scorri(okCard); t.focus({ preventScroll: true }); } }
    if (errori) { scorri(errori); errori.focus({ preventScroll: true }); }

    if (formato === 'sessioni') {
      // Con lo script il riepilogo sostituisce la tendina (che resta nel modulo, nascosta, e porta il valore).
      tutti('[data-vsb-solo-script]', radice).forEach(function (el) { el.hidden = false; });
      tutti('[data-vsb-senza-script]', radice).forEach(function (el) { el.hidden = true; });
      if (tendina) tendina.required = false;

      var etichette = {};
      pulsanti.forEach(function (b) { etichette[b.getAttribute('data-vsb-sessione')] = b.getAttribute('data-vsb-etichetta'); });

      // Sessioni già iniziate: le disattiva il browser, alla sua ora (il server non le filtra).
      var spegni = function () {
        var ora = Date.now() / 1000;
        pulsanti.forEach(function (b) {
          if (Number(b.getAttribute('data-vsb-inizio')) <= ora && !b.disabled) {
            b.disabled = true;
            if (b.getAttribute('data-vsb-sessione') === scelta) seleziona('', false);
          }
        });
        if (tendina) tutti('option[data-vsb-inizio]', tendina).forEach(function (o) { if (Number(o.getAttribute('data-vsb-inizio')) <= ora) o.disabled = true; });
      };

      var seleziona = function (valore, daUtente) {
        var etichetta = etichette[valore];
        var bottone = pulsanti.filter(function (b) { return b.getAttribute('data-vsb-sessione') === valore; })[0];
        if (!etichetta || !bottone || bottone.disabled) valore = '';
        scelta = valore;
        pulsanti.forEach(function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-vsb-sessione') === valore ? 'true' : 'false'); });
        var parti = valore ? valore.split('|') : ['', ''];
        if (tendina) tendina.value = valore;
        if (campoGiorno) campoGiorno.value = parti[0];
        if (campoOra) campoOra.value = parti[1];
        if (oggetto) oggetto.value = oggetto.getAttribute('data-vsb-prefisso') + (valore ? ' — ' + etichetta.replace(' · ', ' ') : '');
        if (quando) quando.textContent = valore ? etichetta : quando.getAttribute('data-vsb-vuoto');
        if (esitoQuando) esitoQuando.textContent = valore ? ' · ' + etichetta : '';
        if (cambia) cambia.textContent = cambia.getAttribute(valore ? 'data-vsb-testo-cambia' : 'data-vsb-testo-scegli');
        if (manca && valore) manca.hidden = true;
        if (annuncio) annuncio.textContent = valore ? annuncio.getAttribute('data-vsb-testo') + ' ' + bottone.getAttribute('aria-label') : '';
        // l'indirizzo segue la scelta, così si può condividere
        try {
          var u = new URL(window.location.href);
          if (valore) { u.searchParams.set('giorno', parti[0]); u.searchParams.set('ora', parti[1]); } else { u.searchParams.delete('giorno'); u.searchParams.delete('ora'); }
          window.history.replaceState(null, '', u.pathname + u.search + u.hash);
        } catch (e) { /* indirizzo non modificabile: la scelta resta comunque nel modulo */ }
        if (daUtente && valore && blocco) {
          scorri(blocco);
          var h = blocco.querySelector('.vsb-prenota__titolo');
          if (h) h.focus({ preventScroll: true });
        }
      };

      pulsanti.forEach(function (b) { b.addEventListener('click', function () { seleziona(b.getAttribute('data-vsb-sessione'), true); }); });
      if (tendina) tendina.addEventListener('change', function () { seleziona(tendina.value, false); });

      spegni();
      window.setInterval(spegni, 60000);

      // ?giorno=AAAA-MM-GG&ora=HH:MM — se la coppia è una sessione la seleziona, altrimenti il parametro è ignorato.
      try {
        var p = new URLSearchParams(window.location.search);
        var g = p.get('giorno'), o = (p.get('ora') || '').slice(0, 5);
        if (g && o) seleziona(g + '|' + o, false);
      } catch (e) { /* niente parametri */ }

      // Il riepilogo dopo l'invio: la sessione arriva dall'indirizzo, se Shopify l'ha conservato.
    }

    if (modulo) {
      modulo.addEventListener('submit', function (ev) {
        // ANTEPRIMA (voce tecnica aperta dall'app): il modulo si vede ma non si invia mai
        if (radice.hasAttribute('data-vsb-anteprima')) { ev.preventDefault(); ev.stopPropagation(); ev.stopImmediatePropagation(); return; }
        if (formato === 'sessioni' && !scelta && !okCard) {
          ev.preventDefault(); ev.stopPropagation(); ev.stopImmediatePropagation();   // ferma anche l'invio dell'anti-spam di Shopify (in ascolto sul documento)
          if (manca) { manca.hidden = false; scorri(manca); var a = manca.querySelector('a'); if (a) a.focus({ preventScroll: true }); }
          return;
        }
        var invia = modulo.querySelector('[data-vsb-invia]');
        if (invia) { var testo = invia.textContent; invia.textContent = invia.getAttribute('data-vsb-testo-invio'); window.setTimeout(function () { invia.disabled = true; }, 0); window.setTimeout(function () { invia.disabled = false; invia.textContent = testo; }, 12000); }
      });
      // I campi che il browser rifiuta prendono il bordo dello stato di errore.
      // Telefono: almeno 6 cifre (spazi, +, trattini e parentesi sono ammessi). Il messaggio è nella lingua della pagina.
      var telefono = modulo.querySelector('[data-vsb-telefono]');
      if (telefono) {
        var controllaTelefono = function () { telefono.setCustomValidity(telefono.value === '' || telefono.value.replace(/\D/g, '').length >= 6 ? '' : telefono.getAttribute('data-vsb-errore')); };
        telefono.addEventListener('input', controllaTelefono); controllaTelefono();
      }
      modulo.addEventListener('invalid', function (ev) { if (ev.target && ev.target.setAttribute) ev.target.setAttribute('aria-invalid', 'true'); }, true);
      modulo.addEventListener('input', function (ev) { if (ev.target && ev.target.checkValidity && ev.target.checkValidity()) ev.target.removeAttribute('aria-invalid'); });
    }
    void titolo;
  }

  /* ═══ 2 · CALENDARIO (L2) ═══ */
  function calendario(cal) {
    var mesi = tutti('[data-vsb-mese]', cal);
    var prec = cal.querySelector('[data-vsb-mese-prec]');
    var succ = cal.querySelector('[data-vsb-mese-succ]');
    var nome = cal.querySelector('[data-vsb-mese-nome]');
    var i = 0;
    cal.classList.add('vsb-calendario--js');
    tutti('[data-vsb-solo-script]', cal).forEach(function (el) { el.hidden = false; });
    function mostra(n) {
      i = Math.max(0, Math.min(mesi.length - 1, n));
      mesi.forEach(function (m, k) { m.hidden = k !== i; });
      if (nome && mesi[i]) nome.textContent = mesi[i].getAttribute('data-vsb-mese');
      if (prec) prec.disabled = i === 0;
      if (succ) succ.disabled = i === mesi.length - 1;
    }
    if (prec) prec.addEventListener('click', function () { mostra(i - 1); });
    if (succ) succ.addEventListener('click', function () { mostra(i + 1); });
    mostra(0);
    return { vai: function (ym) { mesi.forEach(function (m, k) { if (m.getAttribute('data-vsb-ym') === ym) mostra(k); }); } };
  }

  /* ═══ 2b · ELENCO (L4): filtro per giorno ═══ */
  function elenco(radice) {
    var card = tutti('[data-vsb-card-evento]', radice);
    var barra = radice.querySelector('[data-vsb-filtro]');
    var etichetta = radice.querySelector('[data-vsb-filtro-giorno]');
    var lista = radice.querySelector('[data-vsb-lista]');
    function filtra(giorno, nome, sposta) {
      card.forEach(function (c) {
        var li = c.closest('li') || c;
        li.hidden = !!giorno && (c.getAttribute('data-vsb-giorni') || '').indexOf('|' + giorno + '|') < 0;
      });
      if (barra) barra.hidden = !giorno;
      if (etichetta) etichetta.textContent = nome || giorno || '';
      if (giorno && sposta) scorri(barra || lista);
    }
    tutti('[data-vsb-filtra]', radice).forEach(function (b) {
      b.addEventListener('click', function () { filtra(b.getAttribute('data-vsb-filtra'), b.getAttribute('data-vsb-giorno-nome'), true); });
    });
    var togli = radice.querySelector('[data-vsb-filtro-togli]');
    if (togli) togli.addEventListener('click', function () { filtra('', '', false); });
    try {
      var g = new URLSearchParams(window.location.search).get('giorno');
      if (g && /^\d{4}-\d{2}-\d{2}$/.test(g)) {
        var b = radice.querySelector('[data-vsb-giorno-cella="' + g + '"]');
        filtra(g, b ? b.getAttribute('data-vsb-giorno-nome') : g, true);
      }
    } catch (e) { /* niente parametri */ }
  }

  /* ═══ 3 · PANNELLO EVENTI (P0) ═══ */
  function pannello(dlg) {
    var biglietti = tutti('[data-vsb-biglietto]', dlg);
    var altri = dlg.querySelector('[data-vsb-altri]');
    var giorni = tutti('[data-vsb-mostra-biglietto]', dlg);
    var pagina = dlg.querySelector('[data-vsb-pagina-link]');
    function mostra(id, bottone) {
      biglietti.forEach(function (b) { b.hidden = b.id !== id; if (b.id === id && pagina) pagina.href = b.getAttribute('data-vsb-url'); });
      giorni.forEach(function (g) { g.setAttribute('aria-pressed', g === bottone ? 'true' : 'false'); });
      if (altri) {
        var n = bottone ? Number(bottone.getAttribute('data-vsb-altri-n') || 0) : 0;
        altri.hidden = n < 1;
        if (n > 0) {
          altri.textContent = altri.getAttribute('data-vsb-testo').replace('__N__', String(n)) + ' →';
          altri.href = altri.getAttribute('data-vsb-base') + '?giorno=' + bottone.getAttribute('data-vsb-giorno-cella');
        }
      }
    }
    if (pagina && biglietti[0]) pagina.href = biglietti[0].getAttribute('data-vsb-url');
    giorni.forEach(function (g) { g.addEventListener('click', function () { mostra(g.getAttribute('data-vsb-mostra-biglietto'), g); }); });

    function chiudi() { if (dlg.open) dlg.close(); }
    tutti('[data-vsb-eventi-chiudi]', dlg).forEach(function (b) { b.addEventListener('click', chiudi); });
    // clic sul velo (fuori dal pannello): il bersaglio è il <dialog> stesso
    dlg.addEventListener('click', function (ev) { if (ev.target === dlg) chiudi(); });
    dlg.addEventListener('close', function () { document.documentElement.classList.remove('vsb-bloccato'); });

    function apri() { if (typeof dlg.showModal !== 'function' || dlg.open) return; dlg.showModal(); document.documentElement.classList.add('vsb-bloccato'); }
    // Anche l'indirizzo apre il pannello: una pagina aperta con #eventi (o che ci arriva dopo) lo mostra subito.
    if (window.location.hash === '#eventi') apri();
    window.addEventListener('hashchange', function () { if (window.location.hash === '#eventi') apri(); });

    // In fase di CATTURA sul documento: i menu costruiti dopo il caricamento (Qikify, anche quello mobile) hanno i loro
    // gestori sui link, e questo deve arrivare prima. Il link #eventi è un INTERRUTTORE: apre il pannello senza cambiare
    // pagina, e a pannello aperto lo chiude.
    document.addEventListener('click', function (ev) {
      // Innesco: un elemento con data-vsb-eventi-apri, oppure QUALSIASI link che finisce con #eventi (es. /pages/calendario-eventi#eventi).
      var innesco = ev.target.closest && (ev.target.closest('[data-vsb-eventi-apri]') || ev.target.closest('a[href]'));
      if (innesco && !innesco.hasAttribute('data-vsb-eventi-apri') && innesco.hash !== '#eventi') innesco = null;
      if (!innesco || typeof dlg.showModal !== 'function') return;   // senza <dialog> il link fa il suo lavoro: porta all'elenco
      ev.preventDefault(); ev.stopPropagation();
      if (dlg.open) { chiudi(); return; }
      // Aperto dal menu del telefono: prima si chiude il menu col SUO pulsante (quello del tema: data-action="toggle-menu",
      // aria-controls → il contenitore del menu), così alla chiusura del pannello sotto c'è la pagina e non il menu.
      tutti('[data-action="toggle-menu"][aria-controls][aria-expanded="true"]').forEach(function (b) {
        var menu = document.getElementById(b.getAttribute('aria-controls'));
        if (menu && menu.contains(innesco)) b.click();
      });
      apri();
    }, true);
  }

  function avvia() {
    tutti('[data-vsb-evento]').forEach(paginaEvento);
    tutti('[data-vsb-calendario]').forEach(calendario);
    tutti('[data-vsb-elenco]').forEach(elenco);
    var pannelli = tutti('dialog[data-vsb-pannello]');
    pannelli.forEach(pannello);
    // Nessun pannello nella pagina (nessun evento nei prossimi 90 giorni): i pulsanti che lo aprirebbero non servono.
    if (!pannelli.length) tutti('button[data-vsb-eventi-apri]').forEach(function (b) { b.hidden = true; });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', avvia); else avvia();
})();
